export default function isGroupTableQuery(tableQuery) {
    if (!tableQuery) {
        return false;
    }
    return tableQuery.type == 2 /* Group */ || isGroupSearch(tableQuery);
}
export function isGroupSearch(tableQuery) {
    if (!tableQuery || tableQuery.type != 1 /* Search */) {
        return false;
    }
    var searchTableQuery = tableQuery;
    return searchTableQuery.searchScope.kind == "Group" /* Group */;
}
export function getGroupIdFromTableQuery(tableQuery) {
    if (tableQuery.type == 2 /* Group */) {
        return tableQuery.folderId;
    }
    if (isGroupSearch(tableQuery)) {
        var singleGroupSearchScope = tableQuery
            .searchScope;
        return singleGroupSearchScope.groupId;
    }
    return null;
}
//# sourceMappingURL=isGroupTableQuery.js.map